
import state from './moduleJourneyState.js'
import mutations from './moduleJourneyMutations.js'
import actions from './moduleJourneyActions.js'
import getters from './moduleJourneyGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
